import './NewVisitHeader.scss'
import { useLocation } from 'react-router-dom'
import { PrimaryButton, SecondaryButton } from 'ui_kit_qmd'
import { styles, text } from './Constants'
import { RESCHEDULE_VISIT_PAGE_PATH } from '../../../../utils/constants'
import { getHeaderPrimaryButtonText } from './helpers/getHeaderPrimaryButtonText'
import { getHeaderSecondaryButtonText } from './helpers/getHeaderSecondaryButtonText'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const NewVisitHeader = ({ primaryClick, secondaryClick, isReviewBook, dontShow }) => {
  const { pathname } = useLocation()
  const isReschedulePage = pathname === RESCHEDULE_VISIT_PAGE_PATH
  const primaryButtonText = getHeaderPrimaryButtonText({ isReviewBook, isReschedulePage })
  const secondaryButtonText = getHeaderSecondaryButtonText({ isReviewBook, isReschedulePage })

  return (
    <div className='new-visit-header-container'>
      <label htmlFor='null' className='new-visit-header-title'>
        {isReschedulePage ? text.RESCHEDULE_VISIT : text.NEW_VISIT}
      </label>
      <div className='new-visit-header-button-container'>
        <SecondaryButton
          id='new-visit-header-close-button'
          btnText={secondaryButtonText}
          onPress={secondaryClick}
          containerStyle={styles.BUTTON_CONTAINER_STYLE}
          labelStyle={styles.LABEL_STYLE}
        />
        {!dontShow && (
          <PrimaryButton
            id='new-visit-header-save-button'
            btnText={primaryButtonText}
            onPress={primaryClick}
            containerStyle={styles.BUTTON_CONTAINER_STYLE}
          />
        )}
      </div>
    </div>
  )
}
